import { render, staticRenderFns } from "./WrappReminder.vue?vue&type=template&id=0e63a623&"
import script from "./WrappReminder.vue?vue&type=script&lang=ts&"
export * from "./WrappReminder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports